var render = function () {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c(
    "tr",
    [
      _c(
        "td",
        {
          staticClass: "boss-center boss-table-4-link-cell",
          attrs: { "data-test": "date" },
        },
        [
          _vm._v("\n    " + _vm._s(_vm.applicationDate) + "\n    "),
          _c("div", { attrs: { "data-test": "time" } }, [
            _vm._v("\n      " + _vm._s(_vm.applicationTime) + "\n    "),
          ]),
        ]
      ),
      _vm._v(" "),
      _c("td", { staticClass: "boss-center" }, [
        _c("span", { attrs: { "data-test": "user-id" } }, [
          _vm._v("ID:" + _vm._s(_vm.entry.user.id)),
        ]),
        _vm._v(" "),
        _vm.entry.user.isDuplicatedEntries
          ? _c("span", [
              _c("br"),
              _vm._v(" "),
              _c(
                "span",
                {
                  directives: [
                    {
                      name: "tooltip",
                      rawName: "v-tooltip",
                      value: {
                        content:
                          "別職種での応募や、過去1年以内の掲載時に応募があった場合に表示されます。",
                      },
                      expression:
                        "{ content: '別職種での応募や、過去1年以内の掲載時に応募があった場合に表示されます。'}",
                    },
                  ],
                  staticClass: "boss-status-label",
                  attrs: { "data-test": "duplicate" },
                },
                [_vm._v("重複応募\n      ")]
              ),
            ])
          : _vm._e(),
        _vm._v(" "),
        _c("div", { attrs: { "data-test": "member-name" } }, [
          _vm._v("\n      " + _vm._s(_vm.memberName) + "\n    "),
        ]),
        _vm._v(" "),
        _c("div", { attrs: { "data-test": "member-summary" } }, [
          _vm._v("\n      " + _vm._s(_vm.memberSummary) + "\n    "),
        ]),
      ]),
      _vm._v(" "),
      _c(
        "td",
        { staticClass: "is-boss-only-pc", attrs: { "data-test": "job-id" } },
        [
          _vm._v("\n    求人ID:" + _vm._s(_vm.entry.job.id) + "\n    "),
          _c("div", { attrs: { "data-test": "job-name" } }, [
            _vm._v("\n      " + _vm._s(_vm.jobName) + "\n    "),
          ]),
        ]
      ),
      _vm._v(" "),
      _c("td", { staticClass: "boss-center" }, [
        _c("div", { staticClass: "boss-layout boss-layout-vertical" }, [
          _c("div", [
            _c("div", { staticClass: "boss-layout boss-layout-gap-small" }, [
              _vm.entry.approachingStatus.scout.isSend
                ? _c("div", [
                    _c(
                      "span",
                      {
                        directives: [
                          {
                            name: "tooltip",
                            rawName: "v-tooltip",
                            value: {
                              content: _vm.entry.approachingStatus.scout
                                .isEffective
                                ? ""
                                : _vm.expiredMessage,
                            },
                            expression:
                              "{ content:entry.approachingStatus.scout.isEffective ? '' : expiredMessage }",
                          },
                        ],
                        staticClass: "pega-scout-label",
                        attrs: {
                          disabled:
                            !_vm.entry.approachingStatus.scout.isEffective,
                          "data-test": "scout-label",
                        },
                      },
                      [_vm._v("スカウト")]
                    ),
                  ])
                : _vm._e(),
              _vm._v(" "),
              _vm.entry.approachingStatus.offerDm.isSend
                ? _c("div", [
                    _c("img", {
                      directives: [
                        {
                          name: "tooltip",
                          rawName: "v-tooltip",
                          value: {
                            content: _vm.entry.approachingStatus.offerDm
                              .isEffective
                              ? "オファーDM"
                              : _vm.expiredMessage,
                          },
                          expression:
                            "{ content:entry.approachingStatus.offerDm.isEffective ? 'オファーDM' : expiredMessage }",
                        },
                      ],
                      class: {
                        "boss-icon-end":
                          !_vm.entry.approachingStatus.offerDm.isEffective,
                      },
                      attrs: {
                        src: require("@/assets/images/icon-offer-dm.svg"),
                        "data-test": "dm-icon",
                      },
                    }),
                  ])
                : _vm._e(),
            ]),
          ]),
          _vm._v(" "),
          _c("div", [
            _c(
              "div",
              {
                staticClass:
                  "boss-layout boss-layout-vertical boss-layout-no-gap",
              },
              _vm._l(
                _vm.entry.approachingStatus.specialFavors,
                function (sendingFavor) {
                  return _c("div", { key: sendingFavor.id }, [
                    _c(
                      "span",
                      {
                        directives: [
                          {
                            name: "tooltip",
                            rawName: "v-tooltip",
                            value: {
                              content: _vm.getSpecialFavorTooltip(sendingFavor),
                            },
                            expression:
                              "{ content: getSpecialFavorTooltip(sendingFavor)}",
                          },
                        ],
                        staticClass:
                          "boss-bonus-check-text boss-bonus-check-text-gap-small boss-check-true",
                        class: { "boss-bonus-end": !sendingFavor.isEffective },
                        attrs: {
                          "data-test": "special-favor-" + sendingFavor.id,
                        },
                      },
                      [_vm._v(_vm._s(sendingFavor.name))]
                    ),
                  ])
                }
              ),
              0
            ),
          ]),
        ]),
      ]),
      _vm._v(" "),
      _c("message-icon-information", {
        attrs: {
          message: _vm.entry.message,
          "is-entry-message-reservation-reserved":
            _vm.entry.isEntryMessageReservationReserved,
        },
      }),
      _vm._v(" "),
      _c("td", { staticClass: "boss-center is-boss-only-pc" }, [
        _c("span", { attrs: { "data-test": "phase" } }, [
          _vm._v(
            _vm._s(
              _vm.convertLabelByIdFromMaster(
                _vm.entry.currentSelection.phaseId,
                _vm.phases
              )
            )
          ),
        ]),
      ]),
      _vm._v(" "),
      _c("td", { staticClass: "boss-center is-boss-only-pc" }, [
        _c("span", { attrs: { "data-test": "status" } }, [
          _vm._v(
            _vm._s(
              _vm.convertLabelByIdFromMaster(
                _vm.entry.currentSelection.statusId,
                _vm.allStatuses
              )
            )
          ),
        ]),
      ]),
      _vm._v(" "),
      _c("td", { staticClass: "pega-remarks-label is-boss-only-pc" }, [
        _c("span", { attrs: { "data-test": "remarks" } }, [
          _vm._v(_vm._s(_vm.entry.remarks)),
        ]),
      ]),
    ],
    1
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }